import { getMessageForwardBody } from 'gcs-common/slices/messages/messageSelector';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ForwardIcon from '../../../img/forward.svg?react';
import LinkifyBlank from '../../LinkifyBlank/LinkifyBlank';
import QuotedMessage from '../QuotedMessage';
import styles from './styles.module.scss';

const ForwardMessage = ({ messageId }) => {
  const forwardBody = useSelector(getMessageForwardBody(messageId));

  return (
    <>
      <div className={styles.forwardHeader}>
        <ForwardIcon className={styles.forwardIcon} />
        Weitergeleitet
      </div>
      <QuotedMessage messageId={messageId} />
      <div className={styles.txtMsgBody}>
        <LinkifyBlank>{forwardBody}</LinkifyBlank>
      </div>
    </>
  );
};

ForwardMessage.propTypes = { messageId: PropTypes.string.isRequired };

export default ForwardMessage;
